/* eslint-disable max-len */
import type { HTMLProps } from 'react';
import React from 'react';
import developerImage from '../assets/images/developer.jpg';
import TextWithImageSection from '../components/TextWithImageSection';
import Title from '../components/Title';
import Category from '../components/Category';
import Text from '../components/Text';
import Media from '../components/Media';

const About = (props: HTMLProps<HTMLDivElement>) => (
    <div {...props}>
        <TextWithImageSection
            text={(
                <>
                    <Category>About</Category>
                    <Title>Real solutions with simplicity</Title>
                    <Text>
                        <p>
                            realCity is an agile team of transportation geeks, developers and IT experts, headquartered in Budapest. Our group has been doing transportation IT projects since 2012.
                        </p>
                        <p>
                            Our passion is to provide rapid, smart and efficient
                            transport solutions to our partners - real solutions with simplicity.
                        </p>
                    </Text>
                </>
            )}
            image={(
                <Media
                    component="img"
                    src={developerImage}
                    variant="right"
                    alt="realCity Real solutions with simplicity"
                />
            )}
            alignment="image-left"
        />
    </div>
);

export default About;
